import React from 'react';
import './Phase5Loading.css';

export default function Phase5Loading({ title = 'Loading INSIGHT Analysis', message }) {
  return (
    <div className="phase5-loading" role="status" aria-live="polite" data-testid="phase5-loading">
      <p className="font-semibold text-slate-800">{title}</p>
      <div className="phase5-loading-track" role="progressbar" aria-label={title}>
        <span className="phase5-loading-motion" />
      </div>
      <p className="text-sm text-slate-600">{message}</p>
    </div>
  );
}
